import { State } from 'model/State';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getFromHamsClientNonExternalAccountAPI } from 'util/mac/api/account/get';

export type DcAppParentMapping = {
  appAccountId: number;
  parentAccountId: number | null;
};

/**
 * Fetches the DC App Parent Mapping for a given partner
 * GET /1.0/public/account/dcAppParentMapping/partner/{partner_id}
 *
 * @param partnerId - The partner ID to fetch mappings for
 * @param state - Redux state object
 * @returns Promise<DcAppParentMapping[]> - Array of app account and parent account mappings
 */
export const fetchDcAppParentMappingByPartner = (partnerId: string, state: State) =>
  fetchWithParamValidation(
    ({ partnerIdValue }) =>
      getFromHamsClientNonExternalAccountAPI(
        `/dcAppParentMapping/partner/${partnerIdValue}`,
        state,
      ),
    {
      partnerIdValue: partnerId,
    },
  );
